export default __webpack_public_path__ + "static/media/silver.f0b5a464.jpg";